import { Component } from '@angular/core';
import { ModalModule, MsiModalRef } from '@msi/cobalt';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { logoutRequest } from '../../+state/user.actions';
import { UserService } from '../../services/user.service';
import { IconModule } from '@msi/cobalt/icon';
import { SessionLogoutComponent } from '../session-logout-component';

@Component({
    selector: 'msi-remote-logout-confirmation',
    templateUrl: './remote-logout-confirmation.component.html',
    styleUrls: ['./remote-logout-confirmation.component.scss'],
    imports: [CommonModule, ModalModule, IconModule]
})

export class RemoteLogoutConfirmationComponent {
    constructor(
        private msiModalRef: MsiModalRef,
        private store: Store,
        private userService: UserService
    ) {}


    confirmLogout() {
        this.store.dispatch(logoutRequest({forced: true}));
        this.msiModalRef.close();
    }


    logoutCurrentSession() {
        this.userService.logout().subscribe();
        this.msiModalRef.close();
    }
}
